import api from 'api';

export const loadDataTableIo = api('POST /api/io/grid');
export const loadIoDetails = api('GET /api/io/:id/details');

export const exportIo = api('POST /api/io/export', {
  responseType: 'blob',
});
export const loadIo = api('GET /api/io/:id');
export const loadDownloadLinks = api('GET /api/io/downloadLinks');
export const createIo = api('POST /api/io');
export const updateIo = api('PUT /api/io/:id');
export const deleteIo = api('DELETE /api/io/:id');
export const resendIo = api('POST /api/io/:id/resend');

export const checkOnExistingIo = api('GET /api/io/check');
export const loadAffiliates = api(`GET /api/io/:businessPartnerId/affiliates`);

export const approveIo = api('POST /api/io/:id/approve');
export const rejectIo = api('POST /api/io/:id/reject');
export const moreInfoIo = api('POST /api/io/:id/more-info');
export const terminateIo = api('POST /api/io/:id/terminate');
export const undoIo = api('POST /api/io/:id/undo');
export const addCommentIo = api('POST /api/io/:id/comment');

//check rename endpoint
export const loadMentionUsers = api('GET /api/gallery-concepts/comments/users');

export const signByPartnerIo = api('POST /api/io/:id/sign-by-partner');
export const signAgreementWithNoChanges = api(
  'POST /api/io/:id/agreement-no-changes'
);

export const checkTerminateIoStatus = api(
  'GET /api/io/:id/checkTerminateIoStatus'
);
